<template>
  <DropDownSelect inner-class="min-w-48 p-1" :disabled="disabled" data-testid="lead-status-select">
    <template #activator="{ open }">
      <button
        type="button"
        class="btn-outline-color-xs whitespace-nowrap"
        :class="{ 'btn-disabled': disabled }"
        :disabled="disabled"
        data-testid="lead-status-trigger"
        @click="open"
      >
        {{ t('LeadDetail.status.changeAction') }}
        <ChevronDownIcon class="lucide-icon-s" />
      </button>
    </template>
    <template #default="{ close }">
      <p class="px-3 pt-2 pb-1 txt-body-s text-subtlest">{{ t('LeadDetail.status.hint') }}</p>
      <ul data-testid="lead-status-options">
        <li v-for="status in leadStatusOrder" :key="status">
          <button
            type="button"
            class="flex w-full items-center gap-2 rounded-sm px-3 py-2 text-left hover:bg-surface-elevation-1"
            :data-testid="`lead-status-option-${status}`"
            @click="select(status, close)"
          >
            <ChipBadge :color="badgeColorByStatus[status]" rounded>{{ t(leadStatusLabelKey(status)) }}</ChipBadge>
            <CheckIcon v-if="status === modelValue" class="ml-auto lucide-icon-s text-icon-primary" />
          </button>
        </li>
      </ul>
    </template>
  </DropDownSelect>
</template>

<script setup lang="ts">
import { ChipBadge } from '@ramp106/omrjs-core-ui'
import { CheckIcon, ChevronDownIcon } from '@ramp106/omrjs-core-ui/icons'
import { useI18n } from 'vue-i18n'

import { LeadStatusEnum } from '@/gql/reviews'
import DropDownSelect from '@/ui/DropDownSelect.vue'

import { badgeColorByStatus, leadStatusLabelKey, leadStatusOrder } from './leadStatus'

const props = defineProps<{
  modelValue: LeadStatusEnum
  disabled?: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: LeadStatusEnum): void
}>()

const { t } = useI18n()

function select(status: LeadStatusEnum, close: () => void) {
  close()
  if (status === props.modelValue) return
  emit('update:modelValue', status)
}
</script>
